<script>
    import Project from '../js/project';
    import Skill from '../js/project';
    import Button from '../js/button';
    import ProjectDisplay from '../components/project_display.svelte';

    const projects = [
        new Project(
            "Language Recognition Model",
            "Exam Project",
            "I made this ML Model for my exam in Machine Learning. I trained several models on a lot of data, so they could identify a language family or even a language from a piece of text. Accuracy was 92%.",
            [
                new Skill("Python", 3),
                new Skill("TensorFlow", 2),
                new Skill("Git", 2),
                new Skill("PyCharm", 4),
            ],
            [
                new Button("GitHub", 'https://github.com/frederikbehr/ML-Language-Identifier'),
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Flrmodel-min.png?alt=media&token=e30035a7-1a89-4482-a0ae-6a6f0a8d3bf7",
            ],
        ),
        /*new Project(
            "Instagram Post Maker",
            "Personal Business Project",
            "I made this program to help promote my Language Learning Apps. It receives data about how to say various phrases in different languages, and then it maps it onto a map above the country, where the language is spoken. As a Language Learner myself, I like these kinds of posts, so I thought others would as well.",
            [
                new Skill("Python", 3),
                new Skill("Pillow", 2),
                new Skill("PyCharm", 3),
            ],
            [],
            [
               
            ],
        ),*/
    ];
</script>

<section id="projects">
    <div id='container'>
        <div id='container-text'>
            <h1>Other projects</h1>
            <div style="height: 12px"/>
            <p>Here you can see my other projects, that I've done, along with the tools and technologies, that I used for them. </p>
        </div>
        <div id="carousel">
            {#each projects as project}
                <ProjectDisplay {project} />
            {/each}
        </div>
    </div>
</section>


<style>
    #container {
        padding-left: 32px;
        padding-right: 0px;
        width: 100vw - 32px;
        height: calc(100vh - 80px);
        background-color: #fff;
        display: flex;
        justify-content: start;
        align-items: center;
        border-bottom: 5px solid rgba(0, 0, 0, 0.9);
    }

    #container-text {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #carousel {
        width: 70%;
        display: flex;
        flex-direction: row;
        overflow-x: auto; 
        white-space: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.9);
        margin-top: 24px;
        margin-bottom: 0px;
    }

    p {
        color: rgba(0, 0, 0, 0.6);
        width: 70%;
        text-align: center;
        line-height: 1.3em;
    }

    @media (max-width: 952px) {
        #container {
            display: block;
            flex-direction: column;
            margin: 0px;
            padding: 0%;
            width: 100vw;
            height: auto;
        }
        #container-text {
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 24px;
            margin-top: 48px;
        }
        #carousel {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow-x: auto; 
            white-space: nowrap;
            -ms-overflow-style: none;
            scrollbar-width: none;
            margin-bottom: 48px;
        }
    }

</style>